import { render, staticRenderFns } from "./ListOfOperativesSignatures.vue?vue&type=template&id=20cb9eaa&"
import script from "./ListOfOperativesSignatures.vue?vue&type=script&lang=js&"
export * from "./ListOfOperativesSignatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports